type Segment = { key: string; index?: number };

function parsePath(path: string): Segment[] {
  return path.split('.').map((part) => {
    const match = /^([^[]+)(?:\[(\d+)\])?$/.exec(part);
    if (!match) throw new Error(`Invalid path segment: ${part}`);
    return { key: match[1], index: match[2] ? Number(match[2]) : undefined };
  });
}

export function setPath<T>(obj: T, path: string, value: unknown): T {
  const segments = parsePath(path);
  const clone = structuredClone(obj) as Record<string, unknown>;

  let cursor: Record<string, unknown> | unknown[] = clone;
  for (let i = 0; i < segments.length; i++) {
    const { key, index } = segments[i];
    const isLast = i === segments.length - 1;

    if (isLast) {
      if (index === undefined) {
        (cursor as Record<string, unknown>)[key] = value;
      } else {
        const arr = (cursor as Record<string, unknown>)[key] as unknown[];
        arr[index] = value;
      }
      break;
    }

    let next = (cursor as Record<string, unknown>)[key];
    if (next === undefined) {
      next = index === undefined ? {} : [];
      (cursor as Record<string, unknown>)[key] = next;
    }
    if (index !== undefined) {
      const arr = next as unknown[];
      if (arr[index] === undefined) arr[index] = {};
      cursor = arr[index] as Record<string, unknown>;
    } else {
      cursor = next as Record<string, unknown>;
    }
  }

  return clone as T;
}
